export default __webpack_public_path__ + "static/media/647.dc8460a1.gif";